<app-header></app-header>
<div class="full-height">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
